// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"974f4f8b93bd5f73","3772":"0326ff75b179d195","7465":"b23b4bcbe5590dc4","8244":"3cb9e656a19db275"}[chunkId] + ".css";
};